import { Header } from "./Header";

const VideoTutorial = () => {
  const videoData = [
    { img: "/videoTutorial_banner/start.png", title: "प्रारंभ" },
    { img: "/videoTutorial_banner/step1.png", title: "नोंदणी करा" },
    {
      img: "/videoTutorial_banner/step2.png",
      title: "लॉगिन करा प्रोफाइल अपडेट करा शोध एक्सप्लोर करा",
    },
    {
      img: "/videoTutorial_banner/step3.png",
      title: "कुलवृक्ष एक्सप्लोर आणि अपडेट करा",
    },
    { img: "/videoTutorial_banner/step4.png", title: "वेबसाइट एक्सप्लोर करा" },
  ];

  return (
    <>
      <div className="w-full bg-white rounded-lg flex flex-col items-center justify-center">
        <Header />
        <img
          src="/videoTutorial_banner/banner-video-tutorial.jpg"
          alt="Information Banner"
          className="w-full object-cover shadow-lg"
        />
      </div>
      <div className="my-32 max-w-[1300px] mx-auto px-4">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-8 mt-10">
          {videoData.map((data, i) => (
            <div key={i} className="bg-gray-200 rounded-xl p-4 relative flex flex-col items-center">
              <img
                src={data.img}
                alt=""
                className="shadow-xl w-3/4 sm:w-2/3 md:w-full -mt-16"
              />
              <h2 className="text-center font-bold text-lg sm:text-xl md:text-2xl my-6 text-red-600">
                {data.title}
              </h2>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default VideoTutorial;
